import React from "react";
import KeyboardArrowRightIcon from "@mui/icons-material/KeyboardArrowRight";
import { useNavigate } from "react-router-dom";

const TopHeader = ({ type }) => {
  const navigate = useNavigate();
  return (
    <div className="bg-body-light">
      {type == "dashboard" && (
        <div className="content content-full">
          <div className="d-flex align-items-sm-center py-2">
            <div className="p-3">
              <p className="mb-2 dashboard-main f2">Main Dashboard</p>
              <p className="h6 font-w500 text-muted mb-0 d-flex gap-1">
                Welcome{" "}
                <a
                  className="font-w600 text-decoration-none"
                  href="javascript:void(0)"
                >
                  VOW
                </a>
                , everything looks great.
              </p>
            </div>
          </div>
        </div>
      )}
      {type == "roles" && (
        <div className="content-top-header content-full">
          <div className="d-flex align-items-sm-center py-2">
            <div className="p-3 w-100">
              <div className="d-flex ac-jb">
                <p className="mb-2 dashboard-main f1">Role List</p>

                <div className="d-flex mt-1 breadcrumb-item">
                  <p className="navi" onClick={() => navigate("/dashboard")}>
                    Dashboard
                  </p>
                  <KeyboardArrowRightIcon className="Icon-root" />
                  <p className="active">Role</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
      {type == "add-role" && (
        <div className="content-top-header content-full">
          <div className="d-flex align-items-sm-center py-2">
            <div className="p-3 w-100">
              <div className="d-flex ac-jb">
                <p className="mb-2 dashboard-main f1">Create Role</p>

                <div className="d-flex mt-1 breadcrumb-item">
                  <p className="navi" onClick={() => navigate("/dashboard")}>
                    Dashboard
                  </p>
                  <KeyboardArrowRightIcon className="Icon-root" />
                  <p className="navi" onClick={() => navigate(-1)}>
                    Role
                  </p>
                  <KeyboardArrowRightIcon className="Icon-root" />
                  <p className="active">Create</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
      {type == "edit-role" && (
        <div className="content-top-header content-full">
          <div className="d-flex align-items-sm-center py-2">
            <div className="p-3 w-100">
              <div className="d-flex ac-jb">
                <p className="mb-2 dashboard-main f1">Edit Role</p>

                <div className="d-flex mt-1 breadcrumb-item">
                  <p className="navi" onClick={() => navigate("/dashboard")}>
                    Dashboard
                  </p>
                  <KeyboardArrowRightIcon className="Icon-root" />
                  <p className="navi" onClick={() => navigate(-1)}>
                    Role
                  </p>
                  <KeyboardArrowRightIcon className="Icon-root" />
                  <p className="active">Edit</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
      {type == "admins" && (
        <div className="content-top-header content-full">
          <div className="d-flex align-items-sm-center py-2">
            <div className="p-3 w-100">
              <div className="d-flex ac-jb">
                <p className="mb-2 dashboard-main f1">Admin List</p>

                <div className="d-flex mt-1 breadcrumb-item">
                  <p className="navi" onClick={() => navigate("/dashboard")}>
                    Dashboard
                  </p>
                  <KeyboardArrowRightIcon className="Icon-root" />
                  <p className="active">Admin</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
      {type == "add-admin" && (
        <div className="content-top-header content-full">
          <div className="d-flex align-items-sm-center py-2">
            <div className="p-3 w-100">
              <div className="d-flex ac-jb">
                <p className="mb-2 dashboard-main f1">Create Admin</p>

                <div className="d-flex mt-1 breadcrumb-item">
                  <p className="navi" onClick={() => navigate("/dashboard")}>
                    Dashboard
                  </p>
                  <KeyboardArrowRightIcon className="Icon-root" />
                  <p className="navi" onClick={() => navigate(-1)}>
                    Admin
                  </p>
                  <KeyboardArrowRightIcon className="Icon-root" />
                  <p className="active">Create</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
      {type == "edit-admin" && (
        <div className="content-top-header content-full">
          <div className="d-flex align-items-sm-center py-2">
            <div className="p-3 w-100">
              <div className="d-flex ac-jb">
                <p className="mb-2 dashboard-main f1">Edit Admin</p>

                <div className="d-flex mt-1 breadcrumb-item">
                  <p className="navi" onClick={() => navigate("/dashboard")}>
                    Dashboard
                  </p>
                  <KeyboardArrowRightIcon className="Icon-root" />
                  <p className="navi" onClick={() => navigate(-1)}>
                    Admin
                  </p>
                  <KeyboardArrowRightIcon className="Icon-root" />
                  <p className="active">Edit</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
      {type == "view-admin" && (
        <div className="content-top-header content-full">
          <div className="d-flex align-items-sm-center py-2">
            <div className="p-3 w-100">
              <div className="d-flex ac-jb">
                <p className="mb-2 dashboard-main f1">View Admin</p>

                <div className="d-flex mt-1 breadcrumb-item">
                  <p className="navi" onClick={() => navigate("/dashboard")}>
                    Dashboard
                  </p>
                  <KeyboardArrowRightIcon className="Icon-root" />
                  <p className="navi" onClick={() => navigate(-1)}>
                    Admin
                  </p>
                  <KeyboardArrowRightIcon className="Icon-root" />
                  <p className="active">View</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
      {type == "states" && (
        <div className="content-top-header content-full">
          <div className="d-flex align-items-sm-center py-2">
            <div className="p-3 w-100">
              <div className="d-flex ac-jb">
                <p className="mb-2 dashboard-main f1">State List</p>

                <div className="d-flex mt-1 breadcrumb-item">
                  <p className="navi" onClick={() => navigate("/dashboard")}>
                    Dashboard
                  </p>
                  <KeyboardArrowRightIcon className="Icon-root" />
                  <p className="active">State</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
      {type == "add-state" && (
        <div className="content-top-header content-full">
          <div className="d-flex align-items-sm-center py-2">
            <div className="p-3 w-100">
              <div className="d-flex ac-jb">
                <p className="mb-2 dashboard-main f1">Create State</p>

                <div className="d-flex mt-1 breadcrumb-item">
                  <p className="navi" onClick={() => navigate("/dashboard")}>
                    Dashboard
                  </p>
                  <KeyboardArrowRightIcon className="Icon-root" />
                  <p className="navi" onClick={() => navigate(-1)}>
                    State
                  </p>
                  <KeyboardArrowRightIcon className="Icon-root" />
                  <p className="active">Create</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
      {type == "edit-state" && (
        <div className="content-top-header content-full">
          <div className="d-flex align-items-sm-center py-2">
            <div className="p-3 w-100">
              <div className="d-flex ac-jb">
                <p className="mb-2 dashboard-main f1">Edit State</p>

                <div className="d-flex mt-1 breadcrumb-item">
                  <p className="navi" onClick={() => navigate("/dashboard")}>
                    Dashboard
                  </p>
                  <KeyboardArrowRightIcon className="Icon-root" />
                  <p className="navi" onClick={() => navigate(-1)}>
                    State
                  </p>
                  <KeyboardArrowRightIcon className="Icon-root" />
                  <p className="active">Edit</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
      {type == "cities" && (
        <div className="content-top-header content-full">
          <div className="d-flex align-items-sm-center py-2">
            <div className="p-3 w-100">
              <div className="d-flex ac-jb">
                <p className="mb-2 dashboard-main f1">City List</p>

                <div className="d-flex mt-1 breadcrumb-item">
                  <p className="navi" onClick={() => navigate("/dashboard")}>
                    Dashboard
                  </p>
                  <KeyboardArrowRightIcon className="Icon-root" />
                  <p className="active">City</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
      {type == "add-city" && (
        <div className="content-top-header content-full">
          <div className="d-flex align-items-sm-center py-2">
            <div className="p-3 w-100">
              <div className="d-flex ac-jb">
                <p className="mb-2 dashboard-main f1">Create City</p>

                <div className="d-flex mt-1 breadcrumb-item">
                  <p className="navi" onClick={() => navigate("/dashboard")}>
                    Dashboard
                  </p>
                  <KeyboardArrowRightIcon className="Icon-root" />
                  <p className="navi" onClick={() => navigate(-1)}>
                    City
                  </p>
                  <KeyboardArrowRightIcon className="Icon-root" />
                  <p className="active">Create</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
      {type == "edit-city" && (
        <div className="content-top-header content-full">
          <div className="d-flex align-items-sm-center py-2">
            <div className="p-3 w-100">
              <div className="d-flex ac-jb">
                <p className="mb-2 dashboard-main f1">Edit City</p>

                <div className="d-flex mt-1 breadcrumb-item">
                  <p className="navi" onClick={() => navigate("/dashboard")}>
                    Dashboard
                  </p>
                  <KeyboardArrowRightIcon className="Icon-root" />
                  <p className="navi" onClick={() => navigate(-1)}>
                    City
                  </p>
                  <KeyboardArrowRightIcon className="Icon-root" />
                  <p className="active">Edit</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
      {type == "locations" && (
        <div className="content-top-header content-full">
          <div className="d-flex align-items-sm-center py-2">
            <div className="p-3 w-100">
              <div className="d-flex ac-jb">
                <p className="mb-2 dashboard-main f1">Location List</p>

                <div className="d-flex mt-1 breadcrumb-item">
                  <p className="navi" onClick={() => navigate("/dashboard")}>
                    Dashboard
                  </p>
                  <KeyboardArrowRightIcon className="Icon-root" />
                  <p className="active">Location</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
      {type == "add-location" && (
        <div className="content-top-header content-full">
          <div className="d-flex align-items-sm-center py-2">
            <div className="p-3 w-100">
              <div className="d-flex ac-jb">
                <p className="mb-2 dashboard-main f1">Create Location</p>

                <div className="d-flex mt-1 breadcrumb-item">
                  <p className="navi" onClick={() => navigate("/dashboard")}>
                    Dashboard
                  </p>
                  <KeyboardArrowRightIcon className="Icon-root" />
                  <p className="navi" onClick={() => navigate(-1)}>
                    Location
                  </p>
                  <KeyboardArrowRightIcon className="Icon-root" />
                  <p className="active">Create</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
      {type == "edit-location" && (
        <div className="content-top-header content-full">
          <div className="d-flex align-items-sm-center py-2">
            <div className="p-3 w-100">
              <div className="d-flex ac-jb">
                <p className="mb-2 dashboard-main f1">Edit City</p>

                <div className="d-flex mt-1 breadcrumb-item">
                  <p className="navi" onClick={() => navigate("/dashboard")}>
                    Dashboard
                  </p>
                  <KeyboardArrowRightIcon className="Icon-root" />
                  <p className="navi" onClick={() => navigate(-1)}>
                    City
                  </p>
                  <KeyboardArrowRightIcon className="Icon-root" />
                  <p className="active">Edit</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
      {type == "users" && (
        <div className="content-top-header content-full">
          <div className="d-flex align-items-sm-center py-2">
            <div className="p-3 w-100">
              <div className="d-flex ac-jb">
                <p className="mb-2 dashboard-main f1">User List</p>

                <div className="d-flex mt-1 breadcrumb-item">
                  <p className="navi" onClick={() => navigate("/dashboard")}>
                    Dashboard
                  </p>
                  <KeyboardArrowRightIcon className="Icon-root" />
                  <p className="active">User</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
      {type == "user" && (
        <div className="content-top-header content-full">
          <div className="d-flex align-items-sm-center py-2">
            <div className="p-3 w-100">
              <div className="d-flex ac-jb">
                <p className="mb-2 dashboard-main f1">User View</p>

                <div className="d-flex mt-1 breadcrumb-item">
                  <p className="navi" onClick={() => navigate("/dashboard")}>
                    Dashboard
                  </p>
                  <KeyboardArrowRightIcon className="Icon-root" />
                  <p className="navi" onClick={() => navigate(-1)}>
                    User
                  </p>
                  <KeyboardArrowRightIcon className="Icon-root" />
                  <p className="active">View</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
      {type == "booked-rooms-view" && (
        <div className="content-top-header content-full">
          <div className="d-flex align-items-sm-center py-2">
            <div className="p-3 w-100">
              <div className="d-flex ac-jb">
                <p className="mb-2 dashboard-main f1">Booking View</p>

                <div className="d-flex mt-1 breadcrumb-item">
                  <p className="navi" onClick={() => navigate("/dashboard")}>
                    Dashboard
                  </p>
                  <KeyboardArrowRightIcon className="Icon-root" />
                  <p className="navi" onClick={() => navigate(-1)}>
                    Booked Rooms
                  </p>
                  <KeyboardArrowRightIcon className="Icon-root" />
                  <p className="active">View</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
      {type == "property-request-list" && (
        <div className="content-top-header content-full">
          <div className="d-flex align-items-sm-center py-2">
            <div className="p-3 w-100">
              <div className="d-flex ac-jb">
                <p className="mb-2 dashboard-main f1">Property Request List</p>

                <div className="d-flex mt-1 breadcrumb-item">
                  <p className="navi" onClick={() => navigate("/dashboard")}>
                    Dashboard
                  </p>
                  <KeyboardArrowRightIcon className="Icon-root" />
                  <p className="active">Property Request List</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
      {type == "property" && (
        <div className="content-top-header content-full">
          <div className="d-flex align-items-sm-center py-2">
            <div className="p-3 w-100">
              <div className="d-flex ac-jb">
                <p className="mb-2 dashboard-main f1">
                  Property Request Create
                </p>

                <div className="d-flex mt-1 breadcrumb-item">
                  <p className="navi" onClick={() => navigate("/dashboard")}>
                    Dashboard
                  </p>
                  <KeyboardArrowRightIcon className="Icon-root" />
                  <p className="navi" onClick={() => navigate(-1)}>
                    Property Request List
                  </p>
                  <KeyboardArrowRightIcon className="Icon-root" />
                  <p className="active">Create</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
      {type == "edit-property" && (
        <div className="content-top-header content-full">
          <div className="d-flex align-items-sm-center py-2">
            <div className="p-3 w-100">
              <div className="d-flex ac-jb">
                <p className="mb-2 dashboard-main f1">Property Edit</p>

                <div className="d-flex mt-1 breadcrumb-item">
                  <p className="navi" onClick={() => navigate("/dashboard")}>
                    Dashboard
                  </p>
                  <KeyboardArrowRightIcon className="Icon-root" />
                  <p className="navi" onClick={() => navigate(-1)}>
                    Property List
                  </p>
                  <KeyboardArrowRightIcon className="Icon-root" />
                  <p className="active">Edit</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
      {type == "property-request-view" && (
        <div className="content-top-header content-full">
          <div className="d-flex align-items-sm-center py-2">
            <div className="p-3 w-100">
              <div className="d-flex ac-jb">
                <p className="mb-2 dashboard-main f1">Property Request View</p>

                <div className="d-flex mt-1 breadcrumb-item">
                  <p className="navi" onClick={() => navigate("/dashboard")}>
                    Dashboard
                  </p>
                  <KeyboardArrowRightIcon className="Icon-root" />
                  <p className="navi" onClick={() => navigate(-1)}>
                    Property Request List
                  </p>
                  <KeyboardArrowRightIcon className="Icon-root" />
                  <p className="active">View</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
      {type == "property-list" && (
        <div className="content-top-header content-full">
          <div className="d-flex align-items-sm-center py-2">
            <div className="p-3 w-100">
              <div className="d-flex ac-jb">
                <p className="mb-2 dashboard-main f1">Property List</p>

                <div className="d-flex mt-1 breadcrumb-item">
                  <p className="navi" onClick={() => navigate("/dashboard")}>
                    Dashboard
                  </p>
                  <KeyboardArrowRightIcon className="Icon-root" />
                  <p className="active">Property List</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
      {type == "full-block" && (
        <div className="content-top-header content-full">
          <div className="d-flex align-items-sm-center py-2">
            <div className="p-3 w-100">
              <div className="d-flex ac-jb">
                <p className="mb-2 dashboard-main f1">Full Block List</p>

                <div className="d-flex mt-1 breadcrumb-item">
                  <p className="navi" onClick={() => navigate("/dashboard")}>
                    Dashboard
                  </p>

                  <KeyboardArrowRightIcon className="Icon-root" />
                  <p className="active">Full Block List</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
      {type == "block" && (
        <div className="content-top-header content-full">
          <div className="d-flex align-items-sm-center py-2">
            <div className="p-3 w-100">
              <div className="d-flex ac-jb">
                <p className="mb-2 dashboard-main f1">Block List</p>

                <div className="d-flex mt-1 breadcrumb-item">
                  <p className="navi" onClick={() => navigate("/dashboard")}>
                    Dashboard
                  </p>

                  <KeyboardArrowRightIcon className="Icon-root" />
                  <p className="active">Block List</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
      {type == "block-view" && (
        <div className="content-top-header content-full">
          <div className="d-flex align-items-sm-center py-2">
            <div className="p-3 w-100">
              <div className="d-flex ac-jb">
                <p className="mb-2 dashboard-main f1">Block View</p>

                <div className="d-flex mt-1 breadcrumb-item">
                  <p className="navi" onClick={() => navigate("/dashboard")}>
                    Dashboard
                  </p>

                  <KeyboardArrowRightIcon className="Icon-root" />
                  <p className="navi" onClick={() => navigate("/block")}>
                    Block List
                  </p>

                  <KeyboardArrowRightIcon className="Icon-root" />
                  <p className="active">View</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
      {type == "add-food" && (
        <div className="content-top-header content-full">
          <div className="d-flex align-items-sm-center py-2">
            <div className="p-3 w-100">
              <div className="d-flex ac-jb">
                <p className="mb-2 dashboard-main f1">Create Food Package</p>

                <div className="d-flex mt-1 breadcrumb-item">
                  <p className="navi" onClick={() => navigate("/dashboard")}>
                    Dashboard
                  </p>
                  <KeyboardArrowRightIcon className="Icon-root" />
                  <p className="navi" onClick={() => navigate(-1)}>
                    Property Details View
                  </p>
                  <KeyboardArrowRightIcon className="Icon-root" />
                  <p className="active">Create</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
      {type == "edit-food" && (
        <div className="content-top-header content-full">
          <div className="d-flex align-items-sm-center py-2">
            <div className="p-3 w-100">
              <div className="d-flex ac-jb">
                <p className="mb-2 dashboard-main f1">Edit Food Package</p>

                <div className="d-flex mt-1 breadcrumb-item">
                  <p className="navi" onClick={() => navigate("/dashboard")}>
                    Dashboard
                  </p>
                  <KeyboardArrowRightIcon className="Icon-root" />
                  <p className="navi" onClick={() => navigate(-1)}>
                    Property Details View
                  </p>
                  <KeyboardArrowRightIcon className="Icon-root" />
                  <p className="active">Edit</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
      {type == "edit-just-walking" && (
        <div className="content-top-header content-full">
          <div className="d-flex align-items-sm-center py-2">
            <div className="p-3 w-100">
              <div className="d-flex ac-jb">
                <p className="mb-2 dashboard-main f1">Just Walking Edit</p>

                <div className="d-flex mt-1 breadcrumb-item">
                  <p className="navi" onClick={() => navigate("/dashboard")}>
                    Dashboard
                  </p>
                  <KeyboardArrowRightIcon className="Icon-root" />
                  <p className="navi" onClick={() => navigate(-1)}>
                    Property Details View
                  </p>
                  <KeyboardArrowRightIcon className="Icon-root" />
                  <p className="active">Edit</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
      {type == "add-just-walking" && (
        <div className="content-top-header content-full">
          <div className="d-flex align-items-sm-center py-2">
            <div className="p-3 w-100">
              <div className="d-flex ac-jb">
                <p className="mb-2 dashboard-main f1">Just Walking Create</p>

                <div className="d-flex mt-1 breadcrumb-item">
                  <p className="navi" onClick={() => navigate("/dashboard")}>
                    Dashboard
                  </p>
                  <KeyboardArrowRightIcon className="Icon-root" />
                  <p className="navi" onClick={() => navigate(-1)}>
                    Property Details View
                  </p>
                  <KeyboardArrowRightIcon className="Icon-root" />
                  <p className="active">Create</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
      {type == "edit-weekend-percen" && (
        <div className="content-top-header content-full">
          <div className="d-flex align-items-sm-center py-2">
            <div className="p-3 w-100">
              <div className="d-flex ac-jb">
                <p className="mb-2 dashboard-main f1">Weekend Percentage</p>
                <div className="d-flex mt-1 breadcrumb-item">
                  <p className="navi" onClick={() => navigate("/dashboard")}>
                    Dashboard
                  </p>
                  <KeyboardArrowRightIcon className="Icon-root" />
                  <p className="navi" onClick={() => navigate(-1)}>
                    Property Details
                  </p>
                  <KeyboardArrowRightIcon className="Icon-root" />
                  <p className="active">Edit</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
      {type == "add-weekend-percen" && (
        <div className="content-top-header content-full">
          <div className="d-flex align-items-sm-center py-2">
            <div className="p-3 w-100">
              <div className="d-flex ac-jb">
                <p className="mb-2 dashboard-main f1">Weekend Percentage</p>

                <div className="d-flex mt-1 breadcrumb-item">
                  <p className="navi" onClick={() => navigate("/dashboard")}>
                    Dashboard
                  </p>
                  <KeyboardArrowRightIcon className="Icon-root" />
                  <p className="navi" onClick={() => navigate(-1)}>
                    Property Details
                  </p>
                  <KeyboardArrowRightIcon className="Icon-root" />
                  <p className="active">Create</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
      {type == "edit-phase" && (
        <div className="content-top-header content-full">
          <div className="d-flex align-items-sm-center py-2">
            <div className="p-3 w-100">
              <div className="d-flex ac-jb">
                <p className="mb-2 dashboard-main f1">Phase Edit</p>
                <div className="d-flex mt-1 breadcrumb-item">
                  <p className="navi" onClick={() => navigate("/dashboard")}>
                    Dashboard
                  </p>
                  <KeyboardArrowRightIcon className="Icon-root" />
                  <p className="navi" onClick={() => navigate(-1)}>
                    Property Details
                  </p>
                  <KeyboardArrowRightIcon className="Icon-root" />
                  <p className="active">Edit</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
      {type == "add-phase" && (
        <div className="content-top-header content-full">
          <div className="d-flex align-items-sm-center py-2">
            <div className="p-3 w-100">
              <div className="d-flex ac-jb">
                <p className="mb-2 dashboard-main f1">Phase Create</p>

                <div className="d-flex mt-1 breadcrumb-item">
                  <p className="navi" onClick={() => navigate("/dashboard")}>
                    Dashboard
                  </p>
                  <KeyboardArrowRightIcon className="Icon-root" />
                  <p className="navi" onClick={() => navigate(-1)}>
                    Property Details
                  </p>
                  <KeyboardArrowRightIcon className="Icon-root" />
                  <p className="active">Create</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
      {type == "edit-room" && (
        <div className="content-top-header content-full">
          <div className="d-flex align-items-sm-center py-2">
            <div className="p-3 w-100">
              <div className="d-flex ac-jb">
                <p className="mb-2 dashboard-main f1">Room Edit</p>
                <div className="d-flex mt-1 breadcrumb-item">
                  <p className="navi" onClick={() => navigate("/dashboard")}>
                    Dashboard
                  </p>
                  <KeyboardArrowRightIcon className="Icon-root" />
                  <p className="navi" onClick={() => navigate(-1)}>
                    Property Details
                  </p>
                  <KeyboardArrowRightIcon className="Icon-root" />
                  <p className="active">Edit</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
      {type == "add-room" && (
        <div className="content-top-header content-full">
          <div className="d-flex align-items-sm-center py-2">
            <div className="p-3 w-100">
              <div className="d-flex ac-jb">
                <p className="mb-2 dashboard-main f1">Room Create</p>

                <div className="d-flex mt-1 breadcrumb-item">
                  <p className="navi" onClick={() => navigate("/dashboard")}>
                    Dashboard
                  </p>
                  <KeyboardArrowRightIcon className="Icon-root" />
                  <p className="navi" onClick={() => navigate(-1)}>
                    Property Details
                  </p>
                  <KeyboardArrowRightIcon className="Icon-root" />
                  <p className="active">Create</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
      {type == "properties-owner-view" && (
        <div className="content-top-header content-full">
          <div className="d-flex align-items-sm-center py-2">
            <div className="p-3 w-100">
              <div className="d-flex ac-jb">
                <p className="mb-2 dashboard-main f1">Property Owner View</p>

                <div className="d-flex mt-1 breadcrumb-item">
                  <p className="navi" onClick={() => navigate("/dashboard")}>
                    Dashboard
                  </p>
                  <KeyboardArrowRightIcon className="Icon-root" />
                  <p className="navi" onClick={() => navigate(-1)}>
                    Property Owner
                  </p>
                  <KeyboardArrowRightIcon className="Icon-root" />
                  <p className="active">View</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
      {type == "room-view" && (
        <div className="content-top-header content-full">
          <div className="d-flex align-items-sm-center py-2">
            <div className="p-3 w-100">
              <div className="d-flex ac-jb">
                <p className="mb-2 dashboard-main f1">Room View</p>

                <div className="d-flex mt-1 breadcrumb-item">
                  <p className="navi" onClick={() => navigate("/dashboard")}>
                    Dashboard
                  </p>
                  <KeyboardArrowRightIcon className="Icon-root" />
                  <p className="navi" onClick={() => navigate(-1)}>
                    Property Details
                  </p>
                  <KeyboardArrowRightIcon className="Icon-root" />
                  <p className="active">View</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
      {type == "property-owner-list" && (
        <div className="content-top-header content-full">
          <div className="d-flex align-items-sm-center py-2">
            <div className="p-3 w-100">
              <div className="d-flex ac-jb">
                <p className="mb-2 dashboard-main f1">Property Owner List</p>

                <div className="d-flex mt-1 breadcrumb-item">
                  <p className="navi" onClick={() => navigate("/dashboard")}>
                    Dashboard
                  </p>
                  <KeyboardArrowRightIcon className="Icon-root" />
                  <p className="active">Property Owner List</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
      {type == "add-property-owner" && (
        <div className="content-top-header content-full">
          <div className="d-flex align-items-sm-center py-2">
            <div className="p-3 w-100">
              <div className="d-flex ac-jb">
                <p className="mb-2 dashboard-main f1">Create Property Owner</p>

                <div className="d-flex mt-1 breadcrumb-item">
                  <p className="navi" onClick={() => navigate("/dashboard")}>
                    Dashboard
                  </p>
                  <KeyboardArrowRightIcon className="Icon-root" />
                  <p className="navi" onClick={() => navigate(-1)}>
                    Property Owner List
                  </p>
                  <KeyboardArrowRightIcon className="Icon-root" />
                  <p className="active">Create</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
      {type == "edit-property-owner" && (
        <div className="content-top-header content-full">
          <div className="d-flex align-items-sm-center py-2">
            <div className="p-3 w-100">
              <div className="d-flex ac-jb">
                <p className="mb-2 dashboard-main f1">Edit Property Owner</p>

                <div className="d-flex mt-1 breadcrumb-item">
                  <p className="navi" onClick={() => navigate("/dashboard")}>
                    Dashboard
                  </p>
                  <KeyboardArrowRightIcon className="Icon-root" />
                  <p className="navi" onClick={() => navigate(-1)}>
                    Property Owner List
                  </p>
                  <KeyboardArrowRightIcon className="Icon-root" />
                  <p className="active">Edit</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
      {type == "receptionist-list" && (
        <div className="content-top-header content-full">
          <div className="d-flex align-items-sm-center py-2">
            <div className="p-3 w-100">
              <div className="d-flex ac-jb">
                <p className="mb-2 dashboard-main f1">Receptionist List</p>

                <div className="d-flex mt-1 breadcrumb-item">
                  <p className="navi" onClick={() => navigate("/dashboard")}>
                    Dashboard
                  </p>
                  <KeyboardArrowRightIcon className="Icon-root" />
                  <p className="active">Receptionist List</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
      {type == "add-receptionist" && (
        <div className="content-top-header content-full">
          <div className="d-flex align-items-sm-center py-2">
            <div className="p-3 w-100">
              <div className="d-flex ac-jb">
                <p className="mb-2 dashboard-main f1">Create Receptionist</p>

                <div className="d-flex mt-1 breadcrumb-item">
                  <p className="navi" onClick={() => navigate("/dashboard")}>
                    Dashboard
                  </p>
                  <KeyboardArrowRightIcon className="Icon-root" />
                  <p className="navi" onClick={() => navigate(-1)}>
                    Receptionist List
                  </p>
                  <KeyboardArrowRightIcon className="Icon-root" />
                  <p className="active">Create</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
      {type == "edit-receptionist" && (
        <div className="content-top-header content-full">
          <div className="d-flex align-items-sm-center py-2">
            <div className="p-3 w-100">
              <div className="d-flex ac-jb">
                <p className="mb-2 dashboard-main f1">Edit Receptionist</p>

                <div className="d-flex mt-1 breadcrumb-item">
                  <p className="navi" onClick={() => navigate("/dashboard")}>
                    Dashboard
                  </p>
                  <KeyboardArrowRightIcon className="Icon-root" />
                  <p className="navi" onClick={() => navigate(-1)}>
                    Receptionist List
                  </p>
                  <KeyboardArrowRightIcon className="Icon-root" />
                  <p className="active">Edit</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
      {type == "view-receptionist" && (
        <div className="content-top-header content-full">
          <div className="d-flex align-items-sm-center py-2">
            <div className="p-3 w-100">
              <div className="d-flex ac-jb">
                <p className="mb-2 dashboard-main f1">View Receptionist</p>

                <div className="d-flex mt-1 breadcrumb-item">
                  <p className="navi" onClick={() => navigate("/dashboard")}>
                    Dashboard
                  </p>
                  <KeyboardArrowRightIcon className="Icon-root" />
                  <p className="navi" onClick={() => navigate(-1)}>
                    Receptionist List
                  </p>
                  <KeyboardArrowRightIcon className="Icon-root" />
                  <p className="active">View</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
      {type == "mcc-list" && (
        <div className="content-top-header content-full">
          <div className="d-flex align-items-sm-center py-2">
            <div className="p-3 w-100">
              <div className="d-flex ac-jb">
                <p className="mb-2 dashboard-main f1">MCC List</p>

                <div className="d-flex mt-1 breadcrumb-item">
                  <p className="navi" onClick={() => navigate("/dashboard")}>
                    Dashboard
                  </p>
                  <KeyboardArrowRightIcon className="Icon-root" />
                  <p className="active">MCC</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
      {type == "add-mcc" && (
        <div className="content-top-header content-full">
          <div className="d-flex align-items-sm-center py-2">
            <div className="p-3 w-100">
              <div className="d-flex ac-jb">
                <p className="mb-2 dashboard-main f1">Create MCC</p>

                <div className="d-flex mt-1 breadcrumb-item">
                  <p className="navi" onClick={() => navigate("/dashboard")}>
                    Dashboard
                  </p>
                  <KeyboardArrowRightIcon className="Icon-root" />
                  <p className="navi" onClick={() => navigate(-1)}>
                    MCC
                  </p>
                  <KeyboardArrowRightIcon className="Icon-root" />
                  <p className="active">Create</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
      {type == "edit-mcc" && (
        <div className="content-top-header content-full">
          <div className="d-flex align-items-sm-center py-2">
            <div className="p-3 w-100">
              <div className="d-flex ac-jb">
                <p className="mb-2 dashboard-main f1">Edit MCC</p>

                <div className="d-flex mt-1 breadcrumb-item">
                  <p className="navi" onClick={() => navigate("/dashboard")}>
                    Dashboard
                  </p>
                  <KeyboardArrowRightIcon className="Icon-root" />
                  <p className="navi" onClick={() => navigate(-1)}>
                    MCC
                  </p>
                  <KeyboardArrowRightIcon className="Icon-root" />
                  <p className="active">Edit</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
      {type == "recommendation-list" && (
        <div className="content-top-header content-full">
          <div className="d-flex align-items-sm-center py-2">
            <div className="p-3 w-100">
              <div className="d-flex ac-jb">
                <p className="mb-2 dashboard-main f1">Recommendation List</p>

                <div className="d-flex mt-1 breadcrumb-item">
                  <p className="navi" onClick={() => navigate("/dashboard")}>
                    Dashboard
                  </p>
                  <KeyboardArrowRightIcon className="Icon-root" />
                  <p className="active">Recommendation</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
      {type == "add-recommendation" && (
        <div className="content-top-header content-full">
          <div className="d-flex align-items-sm-center py-2">
            <div className="p-3 w-100">
              <div className="d-flex ac-jb">
                <p className="mb-2 dashboard-main f1">Create Recommendation</p>

                <div className="d-flex mt-1 breadcrumb-item">
                  <p className="navi" onClick={() => navigate("/dashboard")}>
                    Dashboard
                  </p>
                  <KeyboardArrowRightIcon className="Icon-root" />
                  <p className="navi" onClick={() => navigate(-1)}>
                    Recommendation
                  </p>
                  <KeyboardArrowRightIcon className="Icon-root" />
                  <p className="active">Create</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
      {type == "edit-recommendation" && (
        <div className="content-top-header content-full">
          <div className="d-flex align-items-sm-center py-2">
            <div className="p-3 w-100">
              <div className="d-flex ac-jb">
                <p className="mb-2 dashboard-main f1">Edit Recommendation</p>

                <div className="d-flex mt-1 breadcrumb-item">
                  <p className="navi" onClick={() => navigate("/dashboard")}>
                    Dashboard
                  </p>
                  <KeyboardArrowRightIcon className="Icon-root" />
                  <p className="navi" onClick={() => navigate(-1)}>
                    Recommendation
                  </p>
                  <KeyboardArrowRightIcon className="Icon-root" />
                  <p className="active">Edit</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
      {type == "subscription-cancel-list" && (
        <div className="content-top-header content-full">
          <div className="d-flex align-items-sm-center py-2">
            <div className="p-3 w-100">
              <div className="d-flex ac-jb">
                <p className="mb-2 dashboard-main f1">Request List</p>

                <div className="d-flex mt-1 breadcrumb-item">
                  <p className="navi" onClick={() => navigate("/dashboard")}>
                    Dashboard
                  </p>
                  <KeyboardArrowRightIcon className="Icon-root" />
                  <p className="active">Request</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
      {type == "recommendation-property-list" && (
        <div className="content-top-header content-full">
          <div className="d-flex align-items-sm-center py-2">
            <div className="p-3 w-100">
              <div className="d-flex ac-jb">
                <p className="mb-2 dashboard-main f1">
                  Recommendation Property List
                </p>

                <div className="d-flex mt-1 breadcrumb-item">
                  <p className="navi" onClick={() => navigate("/dashboard")}>
                    Dashboard
                  </p>
                  <KeyboardArrowRightIcon className="Icon-root" />
                  <p className="active" onClick={() => navigate(-1)}>
                    Recommendation Property
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
      {type == "subscription-cancel-properties" && (
        <div className="content-top-header content-full">
          <div className="d-flex align-items-sm-center py-2">
            <div className="p-3 w-100">
              <div className="d-flex ac-jb">
                <p className="mb-2 dashboard-main f1">
                  Property Subscription Canceled List
                </p>

                <div className="d-flex mt-1 breadcrumb-item">
                  <p className="navi" onClick={() => navigate("/dashboard")}>
                    Dashboard
                  </p>
                  <KeyboardArrowRightIcon className="Icon-root" />
                  <p className="active">Canceled</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
      {type == "reccomendation-list" && (
        <div className="content-top-header content-full">
          <div className="d-flex align-items-sm-center py-2">
            <div className="p-3 w-100">
              <div className="d-flex ac-jb">
                <p className="mb-2 dashboard-main f1">Reccomendation List</p>

                <div className="d-flex mt-1 breadcrumb-item">
                  <p className="navi" onClick={() => navigate("/dashboard")}>
                    Dashboard
                  </p>
                  <KeyboardArrowRightIcon className="Icon-root" />
                  <p className="active">Reccomendation</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
      {type == "subscription-list" && (
        <div className="content-top-header content-full">
          <div className="d-flex align-items-sm-center py-2">
            <div className="p-3 w-100">
              <div className="d-flex ac-jb">
                <p className="mb-2 dashboard-main f1">Subscription List</p>

                <div className="d-flex mt-1 breadcrumb-item">
                  <p className="navi" onClick={() => navigate("/dashboard")}>
                    Dashboard
                  </p>
                  <KeyboardArrowRightIcon className="Icon-root" />
                  <p className="active">Subscription</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
      {type == "services" && (
        <div className="content-top-header content-full">
          <div className="d-flex align-items-sm-center py-2">
            <div className="p-3 w-100">
              <div className="d-flex ac-jb">
                <p className="mb-2 dashboard-main f1">Service List</p>

                <div className="d-flex mt-1 breadcrumb-item">
                  <p className="navi" onClick={() => navigate("/dashboard")}>
                    Dashboard
                  </p>
                  <KeyboardArrowRightIcon className="Icon-root" />
                  <p className="active">Service</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
      {type == "add-service" && (
        <div className="content-top-header content-full">
          <div className="d-flex align-items-sm-center py-2">
            <div className="p-3 w-100">
              <div className="d-flex ac-jb">
                <p className="mb-2 dashboard-main f1">Create Service</p>

                <div className="d-flex mt-1 breadcrumb-item">
                  <p className="navi" onClick={() => navigate("/dashboard")}>
                    Dashboard
                  </p>
                  <KeyboardArrowRightIcon className="Icon-root" />
                  <p className="navi" onClick={() => navigate(-1)}>
                    Service
                  </p>
                  <KeyboardArrowRightIcon className="Icon-root" />
                  <p className="active">Create</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
      {type == "edit-service" && (
        <div className="content-top-header content-full">
          <div className="d-flex align-items-sm-center py-2">
            <div className="p-3 w-100">
              <div className="d-flex ac-jb">
                <p className="mb-2 dashboard-main f1">Edit Service</p>

                <div className="d-flex mt-1 breadcrumb-item">
                  <p className="navi" onClick={() => navigate("/dashboard")}>
                    Dashboard
                  </p>
                  <KeyboardArrowRightIcon className="Icon-root" />
                  <p className="navi" onClick={() => navigate(-1)}>
                    Service
                  </p>
                  <KeyboardArrowRightIcon className="Icon-root" />
                  <p className="active">Edit</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
      {type == "hotel-category" && (
        <div className="content-top-header content-full">
          <div className="d-flex align-items-sm-center py-2">
            <div className="p-3 w-100">
              <div className="d-flex ac-jb">
                <p className="mb-2 dashboard-main f1">Hotel Category List</p>

                <div className="d-flex mt-1 breadcrumb-item">
                  <p className="navi" onClick={() => navigate("/dashboard")}>
                    Dashboard
                  </p>
                  <KeyboardArrowRightIcon className="Icon-root" />
                  <p className="active">Hotel Category</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
      {type == "add-hotel-category" && (
        <div className="content-top-header content-full">
          <div className="d-flex align-items-sm-center py-2">
            <div className="p-3 w-100">
              <div className="d-flex ac-jb">
                <p className="mb-2 dashboard-main f1">Create Hotel Category</p>

                <div className="d-flex mt-1 breadcrumb-item">
                  <p className="navi" onClick={() => navigate("/dashboard")}>
                    Dashboard
                  </p>
                  <KeyboardArrowRightIcon className="Icon-root" />
                  <p className="navi" onClick={() => navigate(-1)}>
                    Hotel Category
                  </p>
                  <KeyboardArrowRightIcon className="Icon-root" />
                  <p className="active">Create</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
      {type == "edit-hotel-category" && (
        <div className="content-top-header content-full">
          <div className="d-flex align-items-sm-center py-2">
            <div className="p-3 w-100">
              <div className="d-flex ac-jb">
                <p className="mb-2 dashboard-main f1">Edit Hotel Category</p>

                <div className="d-flex mt-1 breadcrumb-item">
                  <p className="navi" onClick={() => navigate("/dashboard")}>
                    Dashboard
                  </p>
                  <KeyboardArrowRightIcon className="Icon-root" />
                  <p className="navi" onClick={() => navigate(-1)}>
                    Hotel Category
                  </p>
                  <KeyboardArrowRightIcon className="Icon-root" />
                  <p className="active">Edit</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
      {type == "timing-slot" && (
        <div className="content-top-header content-full">
          <div className="d-flex align-items-sm-center py-2">
            <div className="p-3 w-100">
              <div className="d-flex ac-jb">
                <p className="mb-2 dashboard-main f1">Timing Slot List</p>

                <div className="d-flex mt-1 breadcrumb-item">
                  <p className="navi" onClick={() => navigate("/dashboard")}>
                    Dashboard
                  </p>
                  <KeyboardArrowRightIcon className="Icon-root" />
                  <p className="active">Timing Slot</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
      {type == "add-timing-slot" && (
        <div className="content-top-header content-full">
          <div className="d-flex align-items-sm-center py-2">
            <div className="p-3 w-100">
              <div className="d-flex ac-jb">
                <p className="mb-2 dashboard-main f1">Create Timing Slot</p>

                <div className="d-flex mt-1 breadcrumb-item">
                  <p className="navi" onClick={() => navigate("/dashboard")}>
                    Dashboard
                  </p>
                  <KeyboardArrowRightIcon className="Icon-root" />
                  <p className="navi" onClick={() => navigate(-1)}>
                    Timing Slot
                  </p>
                  <KeyboardArrowRightIcon className="Icon-root" />
                  <p className="active">Create</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
      {type == "edit-timing-slot" && (
        <div className="content-top-header content-full">
          <div className="d-flex align-items-sm-center py-2">
            <div className="p-3 w-100">
              <div className="d-flex ac-jb">
                <p className="mb-2 dashboard-main f1">Edit Timing Slot</p>

                <div className="d-flex mt-1 breadcrumb-item">
                  <p className="navi" onClick={() => navigate("/dashboard")}>
                    Dashboard
                  </p>
                  <KeyboardArrowRightIcon className="Icon-root" />
                  <p className="navi" onClick={() => navigate(-1)}>
                    Timing Slot
                  </p>
                  <KeyboardArrowRightIcon className="Icon-root" />
                  <p className="active">Edit</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
      {type == "room-category" && (
        <div className="content-top-header content-full">
          <div className="d-flex align-items-sm-center py-2">
            <div className="p-3 w-100">
              <div className="d-flex ac-jb">
                <p className="mb-2 dashboard-main f1">Room Category List</p>

                <div className="d-flex mt-1 breadcrumb-item">
                  <p className="navi" onClick={() => navigate("/dashboard")}>
                    Dashboard
                  </p>
                  <KeyboardArrowRightIcon className="Icon-root" />
                  <p className="active">Room Category</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
      {type == "add-room-category" && (
        <div className="content-top-header content-full">
          <div className="d-flex align-items-sm-center py-2">
            <div className="p-3 w-100">
              <div className="d-flex ac-jb">
                <p className="mb-2 dashboard-main f1">Create Room Category</p>

                <div className="d-flex mt-1 breadcrumb-item">
                  <p className="navi" onClick={() => navigate("/dashboard")}>
                    Dashboard
                  </p>
                  <KeyboardArrowRightIcon className="Icon-root" />
                  <p className="navi" onClick={() => navigate(-1)}>
                    Room Category
                  </p>
                  <KeyboardArrowRightIcon className="Icon-root" />
                  <p className="active">Create</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
      {type == "edit-room-category" && (
        <div className="content-top-header content-full">
          <div className="d-flex align-items-sm-center py-2">
            <div className="p-3 w-100">
              <div className="d-flex ac-jb">
                <p className="mb-2 dashboard-main f1">Edit Room Category</p>

                <div className="d-flex mt-1 breadcrumb-item">
                  <p className="navi" onClick={() => navigate("/dashboard")}>
                    Dashboard
                  </p>
                  <KeyboardArrowRightIcon className="Icon-root" />
                  <p className="navi" onClick={() => navigate(-1)}>
                    Room Category
                  </p>
                  <KeyboardArrowRightIcon className="Icon-root" />
                  <p className="active">Edit</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
      {type == "room-booking-list" && (
        <div className="content-top-header content-full">
          <div className="d-flex align-items-sm-center py-2">
            <div className="p-3 w-100">
              <div className="d-flex ac-jb">
                <p className="mb-2 dashboard-main f1">Booking List</p>

                <div className="d-flex mt-1 breadcrumb-item">
                  <p className="navi" onClick={() => navigate("/dashboard")}>
                    Dashboard
                  </p>
                  <KeyboardArrowRightIcon className="Icon-root" />
                  <p className="active">Booking</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
      {type == "today-earnings" && (
        <div className="content-top-header content-full">
          <div className="d-flex align-items-sm-center py-2">
            <div className="p-3 w-100">
              <div className="d-flex ac-jb">
                <p className="mb-2 dashboard-main f1">Today Earnings List</p>

                <div className="d-flex mt-1 breadcrumb-item">
                  <p className="navi" onClick={() => navigate("/dashboard")}>
                    Dashboard
                  </p>
                  <KeyboardArrowRightIcon className="Icon-root" />
                  <p className="active">Today Earnings</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
      {type == "cancelled-bookings-list" && (
        <div className="content-top-header content-full">
          <div className="d-flex align-items-sm-center py-2">
            <div className="p-3 w-100">
              <div className="d-flex ac-jb">
                <p className="mb-2 dashboard-main f1">Cancelled Booking List</p>

                <div className="d-flex mt-1 breadcrumb-item">
                  <p className="navi" onClick={() => navigate("/dashboard")}>
                    Dashboard
                  </p>
                  <KeyboardArrowRightIcon className="Icon-root" />
                  <p className="active">Cancelled Booking</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
      {type == "tips" && (
        <div className="content-top-header content-full">
          <div className="d-flex align-items-sm-center py-2">
            <div className="p-3 w-100">
              <div className="d-flex ac-jb">
                <p className="mb-2 dashboard-main f1">Tips List</p>

                <div className="d-flex mt-1 breadcrumb-item">
                  <p className="navi" onClick={() => navigate("/dashboard")}>
                    Dashboard
                  </p>
                  <KeyboardArrowRightIcon className="Icon-root" />
                  <p className="active">Tips</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
      {type == "user-support-list" && (
        <div className="content-top-header content-full">
          <div className="d-flex align-items-sm-center py-2">
            <div className="p-3 w-100">
              <div className="d-flex ac-jb">
                <p className="mb-2 dashboard-main f1">User Support List</p>

                <div className="d-flex mt-1 breadcrumb-item">
                  <p className="navi" onClick={() => navigate("/dashboard")}>
                    Dashboard
                  </p>
                  <KeyboardArrowRightIcon className="Icon-root" />
                  <p className="active">User Support</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
      {type == "owner-support-list" && (
        <div className="content-top-header content-full">
          <div className="d-flex align-items-sm-center py-2">
            <div className="p-3 w-100">
              <div className="d-flex ac-jb">
                <p className="mb-2 dashboard-main f1">
                  Property Owner Support List
                </p>

                <div className="d-flex mt-1 breadcrumb-item">
                  <p className="navi" onClick={() => navigate("/dashboard")}>
                    Dashboard
                  </p>
                  <KeyboardArrowRightIcon className="Icon-root" />
                  <p className="active">Property Owner Support</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
      {type == "receptionist-support-list" && (
        <div className="content-top-header content-full">
          <div className="d-flex align-items-sm-center py-2">
            <div className="p-3 w-100">
              <div className="d-flex ac-jb">
                <p className="mb-2 dashboard-main f1">
                  Receptionist Support List
                </p>

                <div className="d-flex mt-1 breadcrumb-item">
                  <p className="navi" onClick={() => navigate("/dashboard")}>
                    Dashboard
                  </p>
                  <KeyboardArrowRightIcon className="Icon-root" />
                  <p className="active">Receptionist Support</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
      {type == "transaction-list" && (
        <div className="content-top-header content-full">
          <div className="d-flex align-items-sm-center py-2">
            <div className="p-3 w-100">
              <div className="d-flex ac-jb">
                <p className="mb-2 dashboard-main f1">Transaction List</p>

                <div className="d-flex mt-1 breadcrumb-item">
                  <p className="navi" onClick={() => navigate("/dashboard")}>
                    Dashboard
                  </p>
                  <KeyboardArrowRightIcon className="Icon-root" />
                  <p className="active">Transaction</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}

      {type == "property-view" && (
        <div className="content-top-header content-full">
          <div className="d-flex align-items-sm-center py-2">
            <div className="p-3 w-100">
              <div className="d-flex ac-jb">
                <p className="mb-2 dashboard-main f1">Property Details</p>

                <div className="d-flex mt-1 breadcrumb-item">
                  <p className="navi" onClick={() => navigate("/dashboard")}>
                    Dashboard
                  </p>
                  <KeyboardArrowRightIcon className="Icon-root" />
                  <p className="navi" onClick={() => navigate(-1)}>
                    Property Details
                  </p>
                  <KeyboardArrowRightIcon className="Icon-root" />
                  <p className="active">View</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}

      {type == "transaction-view" && (
        <div className="content-top-header content-full">
          <div className="d-flex align-items-sm-center py-2">
            <div className="p-3 w-100">
              <div className="d-flex ac-jb">
                <p className="mb-2 dashboard-main f1">Transaction View</p>

                <div className="d-flex mt-1 breadcrumb-item">
                  <p className="navi" onClick={() => navigate("/dashboard")}>
                    Dashboard
                  </p>
                  <KeyboardArrowRightIcon className="Icon-root" />
                  <p className="navi" onClick={() => navigate(-1)}>
                    Transaction
                  </p>
                  <KeyboardArrowRightIcon className="Icon-root" />
                  <p className="active">View</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}

      {type == "coupon-list" && (
        <div className="content-top-header content-full">
          <div className="d-flex align-items-sm-center py-2">
            <div className="p-3 w-100">
              <div className="d-flex ac-jb">
                <p className="mb-2 dashboard-main f1">Coupon List</p>

                <div className="d-flex mt-1 breadcrumb-item">
                  <p className="navi" onClick={() => navigate("/dashboard")}>
                    Dashboard
                  </p>
                  <KeyboardArrowRightIcon className="Icon-root" />
                  <p className="active">Coupon</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}

      {type == "add-coupon" && (
        <div className="content-top-header content-full">
          <div className="d-flex align-items-sm-center py-2">
            <div className="p-3 w-100">
              <div className="d-flex ac-jb">
                <p className="mb-2 dashboard-main f1">Create Coupon</p>

                <div className="d-flex mt-1 breadcrumb-item">
                  <p className="navi" onClick={() => navigate("/dashboard")}>
                    Dashboard
                  </p>
                  <KeyboardArrowRightIcon className="Icon-root" />
                  <p className="navi" onClick={() => navigate(-1)}>
                    Coupon
                  </p>
                  <KeyboardArrowRightIcon className="Icon-root" />
                  <p className="active">Create</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
      {type == "edit-coupon" && (
        <div className="content-top-header content-full">
          <div className="d-flex align-items-sm-center py-2">
            <div className="p-3 w-100">
              <div className="d-flex ac-jb">
                <p className="mb-2 dashboard-main f1">Edit Coupon</p>

                <div className="d-flex mt-1 breadcrumb-item">
                  <p className="navi" onClick={() => navigate("/dashboard")}>
                    Dashboard
                  </p>
                  <KeyboardArrowRightIcon className="Icon-root" />
                  <p className="navi" onClick={() => navigate(-1)}>
                    Coupon
                  </p>
                  <KeyboardArrowRightIcon className="Icon-root" />
                  <p className="active">Edit</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
      {type == "view-coupon" && (
        <div className="content-top-header content-full">
          <div className="d-flex align-items-sm-center py-2">
            <div className="p-3 w-100">
              <div className="d-flex ac-jb">
                <p className="mb-2 dashboard-main f1">View Coupon</p>

                <div className="d-flex mt-1 breadcrumb-item">
                  <p className="navi" onClick={() => navigate("/dashboard")}>
                    Dashboard
                  </p>
                  <KeyboardArrowRightIcon className="Icon-root" />
                  <p className="navi" onClick={() => navigate(-1)}>
                    Coupon
                  </p>
                  <KeyboardArrowRightIcon className="Icon-root" />
                  <p className="active">View</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}

      {type == "today-earning-view" && (
        <div className="content-top-header content-full">
          <div className="d-flex align-items-sm-center py-2">
            <div className="p-3 w-100">
              <div className="d-flex ac-jb">
                <p className="mb-2 dashboard-main f1">Today Earning View</p>

                <div className="d-flex mt-1 breadcrumb-item">
                  <p className="navi" onClick={() => navigate("/dashboard")}>
                    Dashboard
                  </p>
                  <KeyboardArrowRightIcon className="Icon-root" />
                  <p className="navi" onClick={() => navigate(-1)}>
                    Today Earning
                  </p>
                  <KeyboardArrowRightIcon className="Icon-root" />
                  <p className="active">View</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}

      {type == "referral-list" && (
        <div className="content-top-header content-full">
          <div className="d-flex align-items-sm-center py-2">
            <div className="p-3 w-100">
              <div className="d-flex ac-jb">
                <p className="mb-2 dashboard-main f1">Referral List</p>

                <div className="d-flex mt-1 breadcrumb-item">
                  <p className="navi" onClick={() => navigate("/dashboard")}>
                    Dashboard
                  </p>
                  <KeyboardArrowRightIcon className="Icon-root" />
                  <p className="active">Referral</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}

      {type == "referral-view" && (
        <div className="content-top-header content-full">
          <div className="d-flex align-items-sm-center py-2">
            <div className="p-3 w-100">
              <div className="d-flex ac-jb">
                <p className="mb-2 dashboard-main f1">Referral</p>

                <div className="d-flex mt-1 breadcrumb-item">
                  <p className="navi" onClick={() => navigate("/dashboard")}>
                    Dashboard
                  </p>
                  <KeyboardArrowRightIcon className="Icon-root" />
                  <p className="navi" onClick={() => navigate(-1)}>
                    Referral
                  </p>
                  <KeyboardArrowRightIcon className="Icon-root" />
                  <p className="active">View</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}

      {type == "banner" && (
        <div className="content-top-header content-full">
          <div className="d-flex align-items-sm-center py-2">
            <div className="p-3 w-100">
              <div className="d-flex ac-jb">
                <p className="mb-2 dashboard-main f1">Banner List</p>

                <div className="d-flex mt-1 breadcrumb-item">
                  <p className="navi" onClick={() => navigate("/dashboard")}>
                    Dashboard
                  </p>
                  <KeyboardArrowRightIcon className="Icon-root" />
                  <p className="active">Banner</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
      {type == "add-banner" && (
        <div className="content-top-header content-full">
          <div className="d-flex align-items-sm-center py-2">
            <div className="p-3 w-100">
              <div className="d-flex ac-jb">
                <p className="mb-2 dashboard-main f1">Create Banner</p>

                <div className="d-flex mt-1 breadcrumb-item">
                  <p className="navi" onClick={() => navigate("/dashboard")}>
                    Dashboard
                  </p>
                  <KeyboardArrowRightIcon className="Icon-root" />
                  <p className="navi" onClick={() => navigate(-1)}>
                    Banner
                  </p>
                  <KeyboardArrowRightIcon className="Icon-root" />
                  <p className="active">Create</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
      {type == "edit-banner" && (
        <div className="content-top-header content-full">
          <div className="d-flex align-items-sm-center py-2">
            <div className="p-3 w-100">
              <div className="d-flex ac-jb">
                <p className="mb-2 dashboard-main f1">Edit Banner</p>

                <div className="d-flex mt-1 breadcrumb-item">
                  <p className="navi" onClick={() => navigate("/dashboard")}>
                    Dashboard
                  </p>
                  <KeyboardArrowRightIcon className="Icon-root" />
                  <p className="navi" onClick={() => navigate(-1)}>
                    Banner
                  </p>
                  <KeyboardArrowRightIcon className="Icon-root" />
                  <p className="active">Edit</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}

      {type == "amenity" && (
        <div className="content-top-header content-full">
          <div className="d-flex align-items-sm-center py-2">
            <div className="p-3 w-100">
              <div className="d-flex ac-jb">
                <p className="mb-2 dashboard-main f1">Amenity List</p>

                <div className="d-flex mt-1 breadcrumb-item">
                  <p className="navi" onClick={() => navigate("/dashboard")}>
                    Dashboard
                  </p>
                  <KeyboardArrowRightIcon className="Icon-root" />
                  <p className="active">Amenity</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
      {type == "add-amenity" && (
        <div className="content-top-header content-full">
          <div className="d-flex align-items-sm-center py-2">
            <div className="p-3 w-100">
              <div className="d-flex ac-jb">
                <p className="mb-2 dashboard-main f1">Create Amenity</p>

                <div className="d-flex mt-1 breadcrumb-item">
                  <p className="navi" onClick={() => navigate("/dashboard")}>
                    Dashboard
                  </p>
                  <KeyboardArrowRightIcon className="Icon-root" />
                  <p className="navi" onClick={() => navigate(-1)}>
                    Amenity
                  </p>
                  <KeyboardArrowRightIcon className="Icon-root" />
                  <p className="active">Create</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
      {type == "edit-amenity" && (
        <div className="content-top-header content-full">
          <div className="d-flex align-items-sm-center py-2">
            <div className="p-3 w-100">
              <div className="d-flex ac-jb">
                <p className="mb-2 dashboard-main f1">Edit Amenity</p>

                <div className="d-flex mt-1 breadcrumb-item">
                  <p className="navi" onClick={() => navigate("/dashboard")}>
                    Dashboard
                  </p>
                  <KeyboardArrowRightIcon className="Icon-root" />
                  <p className="navi" onClick={() => navigate(-1)}>
                    Amenity
                  </p>
                  <KeyboardArrowRightIcon className="Icon-root" />
                  <p className="active">Edit</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}

      {type == "review-list" && (
        <div className="content-top-header content-full">
          <div className="d-flex align-items-sm-center py-2">
            <div className="p-3 w-100">
              <div className="d-flex ac-jb">
                <p className="mb-2 dashboard-main f1">Review List</p>

                <div className="d-flex mt-1 breadcrumb-item">
                  <p className="navi" onClick={() => navigate("/dashboard")}>
                    Dashboard
                  </p>
                  <KeyboardArrowRightIcon className="Icon-root" />
                  <p className="active">Review</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}

      {type == "review-view" && (
        <div className="content-top-header content-full">
          <div className="d-flex align-items-sm-center py-2">
            <div className="p-3 w-100">
              <div className="d-flex ac-jb">
                <p className="mb-2 dashboard-main f1">View Review</p>

                <div className="d-flex mt-1 breadcrumb-item">
                  <p className="navi" onClick={() => navigate("/dashboard")}>
                    Dashboard
                  </p>
                  <KeyboardArrowRightIcon className="Icon-root" />
                  <p className="navi" onClick={() => navigate(-1)}>
                    Review
                  </p>
                  <KeyboardArrowRightIcon className="Icon-root" />
                  <p className="active">View</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}

      {type == "report-list" && (
        <div className="content-top-header content-full">
          <div className="d-flex align-items-sm-center py-2">
            <div className="p-3 w-100">
              <div className="d-flex ac-jb">
                <p className="mb-2 dashboard-main f1">Report List</p>

                <div className="d-flex mt-1 breadcrumb-item">
                  <p className="navi" onClick={() => navigate("/dashboard")}>
                    Dashboard
                  </p>
                  <KeyboardArrowRightIcon className="Icon-root" />
                  <p className="active">Report</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}

      {type == "wishlist" && (
        <div className="content-top-header content-full">
          <div className="d-flex align-items-sm-center py-2">
            <div className="p-3 w-100">
              <div className="d-flex ac-jb">
                <p className="mb-2 dashboard-main f1">Wishlist Property List</p>

                <div className="d-flex mt-1 breadcrumb-item">
                  <p className="navi" onClick={() => navigate("/dashboard")}>
                    Dashboard
                  </p>
                  <KeyboardArrowRightIcon className="Icon-root" />
                  <p className="active">Wishlist Property</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}

      {type == "wishlist-view" && (
        <div className="content-top-header content-full">
          <div className="d-flex align-items-sm-center py-2">
            <div className="p-3 w-100">
              <div className="d-flex ac-jb">
                <p className="mb-2 dashboard-main f1">View Wishlist Property</p>

                <div className="d-flex mt-1 breadcrumb-item">
                  <p className="navi" onClick={() => navigate("/dashboard")}>
                    Dashboard
                  </p>
                  <KeyboardArrowRightIcon className="Icon-root" />
                  <p className="navi" onClick={() => navigate(-1)}>
                    Wishlist Property
                  </p>
                  <KeyboardArrowRightIcon className="Icon-root" />
                  <p className="active">View</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}

      {type == "bank-accounts" && (
        <div className="content-top-header content-full">
          <div className="d-flex align-items-sm-center py-2">
            <div className="p-3 w-100">
              <div className="d-flex ac-jb">
                <p className="mb-2 dashboard-main f1">Bank Account List</p>

                <div className="d-flex mt-1 breadcrumb-item">
                  <p className="navi" onClick={() => navigate("/dashboard")}>
                    Dashboard
                  </p>
                  <KeyboardArrowRightIcon className="Icon-root" />
                  <p className="active">Bank Account</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}

      {type == "bank-accounts-view" && (
        <div className="content-top-header content-full">
          <div className="d-flex align-items-sm-center py-2">
            <div className="p-3 w-100">
              <div className="d-flex ac-jb">
                <p className="mb-2 dashboard-main f1">View Bank Account</p>

                <div className="d-flex mt-1 breadcrumb-item">
                  <p className="navi" onClick={() => navigate("/dashboard")}>
                    Dashboard
                  </p>
                  <KeyboardArrowRightIcon className="Icon-root" />
                  <p className="navi" onClick={() => navigate(-1)}>
                    Bank Account
                  </p>
                  <KeyboardArrowRightIcon className="Icon-root" />
                  <p className="active">View</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default TopHeader;
